export enum FieldType {
  Boolean = "Boolean",
  String = "String",
  Number = "Number",
  Array = "Array",
  Object = "Object",
  RawJSON = "Raw JSON"
}

export enum EditorMode {
  Tree = "Tree",
  Text = "Text"
}
